<template>
  <div
    class="w-full fixed mt-4 z-40 flex"
    v-for="(value, key) in errors"
    :key="key"
  >
    <div class="bg-red-600 mx-auto rounded">
      <div class="mx-auto py-3 px-3 sm:px-6 lg:px-8">
        <div class="flex items-center justify-between flex-wrap">
          <div class="flex-1 flex items-center">
            <span class="flex p-2 rounded-lg bg-red-800">
              <Icon name="EmojiSad" class="w-6 h-6 text-white" />
            </span>
            <p class="ml-3 font-medium text-white">
              {{ value }}
            </p>
          </div>
          <div class="order-2 flex-shrink-0 sm:order-3 sm:ml-3">
            <button
              type="button"
              class="-mr-1 flex p-2 rounded-md hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-white sm:-mr-2"
            >
              <span class="sr-only">Dismiss</span>
              <Icon name="Close" class="h-6 w-6 text-white" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import Icon from "@/components/UI/Icon";

export default {
  components: { Icon },
  setup() {
    const store = useStore();

    const errors = computed(() => store.state.alert.errors);

    return { errors };
  },
};
</script>

<style></style>
